(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bx-reviews-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      var scope = root || document;
      var wraps = scope.querySelectorAll('.bxrc');
      Array.prototype.forEach.call(wraps, function (wrap) {
        if (wrap.__bxrcInit) return; wrap.__bxrcInit = true;
        var vp = wrap.querySelector('[data-bxrc-viewport]');
        var nav = wrap.querySelector('[data-bxrc-nav]');
        if (!vp) return;
        var prev = nav && nav.querySelector('[data-bxrc-prev]');
        var next = nav && nav.querySelector('[data-bxrc-next]');
        function cardStep() {
          var card = vp.querySelector('.bxrc__card');
          if (!card) return vp.clientWidth;
          var gap = parseFloat(getComputedStyle(vp.querySelector('.bxrc__track')).gap) || 20;
          return card.getBoundingClientRect().width + gap;
        }
        function sync() {
          if (!prev) return;
          prev.disabled = vp.scrollLeft <= 2;
          next.disabled = vp.scrollLeft >= (vp.scrollWidth - vp.clientWidth - 2);
        }
        if (prev) prev.addEventListener('click', function () { vp.scrollBy({ left: -cardStep(), behavior: 'smooth' }); });
        if (next) next.addEventListener('click', function () { vp.scrollBy({ left: cardStep(), behavior: 'smooth' }); });
        vp.addEventListener('scroll', function () { window.requestAnimationFrame(sync); });
        var down = false, moved = false, startX = 0, startScroll = 0;
        vp.addEventListener('mousedown', function (e) { down = true; moved = false; startX = e.pageX; startScroll = vp.scrollLeft; });
        window.addEventListener('mousemove', function (e) {
          if (!down) return; var dx = e.pageX - startX;
          if (Math.abs(dx) > 5) { moved = true; vp.classList.add('is-grabbing'); }
          if (moved) { vp.scrollLeft = startScroll - dx; e.preventDefault(); }
        });
        window.addEventListener('mouseup', function () { down = false; vp.classList.remove('is-grabbing'); });
        vp.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
        vp.addEventListener('dragstart', function (e) { e.preventDefault(); });
        sync();
      });
    }
    if (document.readyState !== 'loading') init();
    else document.addEventListener('DOMContentLoaded', function () { init(); });
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
